module.exports = __webpack_public_path__ + "static/2_3_game-tree-4_FI-e81aae84274925b02667042ca545d14f.svg";